import { render, staticRenderFns } from "./RelatedDamageReports.vue?vue&type=template&id=1986da67&scoped=true&"
import script from "./RelatedDamageReports.vue?vue&type=script&lang=js&"
export * from "./RelatedDamageReports.vue?vue&type=script&lang=js&"
import style0 from "./RelatedDamageReports.vue?vue&type=style&index=0&id=1986da67&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1986da67",
  null
  
)

export default component.exports